/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */
/* eslint-disable */

import React from "react";
import "./Footer.css";
import { translate } from "react-i18next";
import { Link } from "react-router-dom";

import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import CookieBanner from "../../components/cookies/CookieConsentBanner";
import LOGO_IMG from "../../assets/logos/motcos_logo.svg";

const Footer = React.memo(() => {
  return (
    <footer className="footer_root">
      <div className="footer_inner">
        <div style={{ minWidth: "300px" }}>
          <img src={LOGO_IMG} alt="motcos logo" className="footer_logo_img" />
        </div>
        <div className="footer_content">
          <h1 className="contact_title">Contact Us</h1>
          <div className="contact_wrapper">
            <div className="content_context">
              <MailOutlineIcon sx={{ color: "rgba(75, 102, 129, 1)", paddingRight: "1vh" }} />
              <p className="content_text">support@motcos.com</p>
            </div>
            <div className="content_context">
              <LocationOnOutlinedIcon
                sx={{ color: "rgba(75, 102, 129, 1)", paddingRight: "1vh" }}
              />
              <p className="content_text">
                Elmos Semiconductor Sales & Solutions GmbH | Heinrich-Hertz-Straße 1 | D-44227
                Dortmund | Germany
              </p>
            </div>
            <div className="content_context">
              <p className="content_text" style={{ paddingRight: "15px" }}>
                <Link style={customeStyles.link} to="/privacy-policy">
                  Privacy Policy
                </Link>
              </p>
              <p className="content_text">
                <Link style={customeStyles.link} to="/imprint">
                  Imprint
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
      <CookieBanner />
    </footer>
  );
});

export default translate(["core"], { wait: true })(Footer);

const customeStyles = {
  link: {
    textDecoration: "none",
    fontSize: "clamp(1rem, 1rem + 0vw, 1rem)",
    color: "#FFF",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "150%",
    letterSpacing: "0.08px",
  },
};
